// constants
import { UserRole } from "../../constants/userRole";
import { UsersActionTypes } from "./constants";

//Action
export interface UsersActionType {
  type:
    | UsersActionTypes.GET_LIST_USERS_ERROR
    | UsersActionTypes.GET_LIST_USERS_SUCCESS
    | UsersActionTypes.GET_LIST_USERS
    | UsersActionTypes.CREATE_USER
    | UsersActionTypes.CREATE_USER_SUCCESS
    | UsersActionTypes.CREATE_USER_ERROR
    | UsersActionTypes.GET_USER
    | UsersActionTypes.GET_USER_SUCCESS
    | UsersActionTypes.GET_USER_ERROR
    | UsersActionTypes.UPDATE_USER
    | UsersActionTypes.UPDATE_USER_SUCCESS
    | UsersActionTypes.UPDATE_USER_ERROR
    | UsersActionTypes.UPDATE_USER_PASSWORD
    | UsersActionTypes.UPDATE_USER_PASSWORD_SUCCESS
    | UsersActionTypes.UPDATE_USER_PASSWORD_ERROR
    | UsersActionTypes.UPDATE_USER_ACTIVATION
    | UsersActionTypes.UPDATE_USER_ACTIVATION_SUCCESS
    | UsersActionTypes.UPDATE_USER_ACTIVATION_ERROR
    | UsersActionTypes.DELETE_USER
    | UsersActionTypes.DELETE_USER_SUCCESS
    | UsersActionTypes.DELETE_USER_ERROR
    | UsersActionTypes.DOWNLOAD_USERS
    | UsersActionTypes.DOWNLOAD_USERS_SUCCESS
    | UsersActionTypes.DOWNLOAD_USERS_ERROR
    | UsersActionTypes.UPDATE_USER_PROFILE_SUCCESS
    | UsersActionTypes.UPDATE_USER_PROFILE_ERROR
    | UsersActionTypes.UPDATE_USER_PROFILE
    | UsersActionTypes.GET_SELLER_LIST
    | UsersActionTypes.GET_SELLER_LIST_SUCCESS
    | UsersActionTypes.GET_SELLER_LIST_ERROR
    | UsersActionTypes.GET_AGENT_LIST
    | UsersActionTypes.GET_AGENT_LIST_SUCCESS
    | UsersActionTypes.GET_AGENT_LIST_ERROR
    | UsersActionTypes.GET_DELIVERY_LIST
    | UsersActionTypes.GET_DELIVERY_LIST_SUCCESS
    | UsersActionTypes.GET_DELIVERY_LIST_ERROR;
  payload: {} | string;
}

//Interfaces
interface UsersData {
  items?: any[];
  total?: number;
  keyword?: string;
  limit?: number;
  skip?: number;
  role?: string;
  country?: string;
}
interface UserCreate {
  name: string;
  role: UserRole;
  email: string;
  password: string;
  phone: string;
  country?: string;
}

interface UserUpdate {
  id: string;
  name: string;
  role: UserRole;
  email: string;
  phone: string;
  packageId: string;
  isEmailVerified: boolean;
  isActivated: boolean;
}

interface UserUpdatePassword {
  id: string;
  password: string;
}

interface UserUpdateActivation {
  id: string;
}

interface GetUser {
  id: string;
}

interface DeleteUser {
  ids: string[];
}

interface UserProfileUpdate {
  name: string;
  phone: string;
  rib?: string;
  cryptoWallet?: string;
  mobileMoney?: string;
}

export const getSellerListSuccess = (
  actionType: string,
  data: UsersData | {}
): UsersActionType => ({
  type: UsersActionTypes.GET_SELLER_LIST_SUCCESS,
  payload: { actionType, data },
});

export const getSellerListError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.GET_SELLER_LIST_ERROR,
  payload: { actionType, error },
});

export const getSellerList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  country: string = ""
): UsersActionType => ({
  type: UsersActionTypes.GET_SELLER_LIST,
  payload: { keyword, limit, skip, role: "seller", country },
});

export const getAgentListSuccess = (
  actionType: string,
  data: UsersData | {}
): UsersActionType => ({
  type: UsersActionTypes.GET_AGENT_LIST_SUCCESS,
  payload: { actionType, data },
});

export const getAgentListError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.GET_AGENT_LIST_ERROR,
  payload: { actionType, error },
});

export const getAgentList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  country: string = ""
): UsersActionType => ({
  type: UsersActionTypes.GET_AGENT_LIST,
  payload: { keyword, limit, skip, role: "agent", country },
});

export const getDeliveryListSuccess = (
  actionType: string,
  data: UsersData | {}
): UsersActionType => ({
  type: UsersActionTypes.GET_DELIVERY_LIST_SUCCESS,
  payload: { actionType, data },
});

export const getDeliveryListError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.GET_DELIVERY_LIST_ERROR,
  payload: { actionType, error },
});

export const getDeliveryList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  country: string = ""
): UsersActionType => ({
  type: UsersActionTypes.GET_DELIVERY_LIST,
  payload: { keyword, limit, skip, role: "delivery", country },
});

export const updateUserProfileSuccess = (
  actionType: string,
  data: UserProfileUpdate | {}
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PROFILE_SUCCESS,
  payload: { actionType, data },
});

export const updateUserProfileError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PROFILE_ERROR,
  payload: { actionType, error },
});

export const updateUserProfile = (
  data: UserProfileUpdate
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PROFILE,
  payload: data,
});

//User_List
export const usersGetListSuccess = (
  actionType: string,
  data: UsersData | {}
): UsersActionType => ({
  type: UsersActionTypes.GET_LIST_USERS_SUCCESS,
  payload: { actionType, data },
});
export const usersGetListError = (
  actionType: string,
  error: any
): UsersActionType => ({
  type: UsersActionTypes.GET_LIST_USERS_ERROR,
  payload: { actionType, error },
});

export const getUserList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  role: string = "",
  country: string = "",
  activated: string = ""
): UsersActionType => ({
  type: UsersActionTypes.GET_LIST_USERS,
  payload: { keyword, limit, skip, role, country, activated },
});

//Create User
export const createUserSuccess = (
  actionType: string,
  data: UserCreate | {}
): UsersActionType => ({
  type: UsersActionTypes.CREATE_USER_SUCCESS,
  payload: { actionType, data },
});
export const createUserError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.CREATE_USER_ERROR,
  payload: { actionType, error },
});
export const createUser = (
  name: string,
  role: UserRole,
  email: string,
  password: string,
  phone: string,
  country?: string,
  accountManager?: string | null,
  commissionRate?: number
): UsersActionType => ({
  type: UsersActionTypes.CREATE_USER,
  payload: {
    name,
    role,
    email,
    password,
    phone,
    country,
    accountManager,
    commissionRate,
  },
});

//Update User
export const updateUserSuccess = (
  actionType: string,
  data: UserUpdate | {}
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_SUCCESS,
  payload: { actionType, data },
});
export const updateUserError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_ERROR,
  payload: { actionType, error },
});

export const updateUser = (id: string, data: UserUpdate): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER,
  payload: { id, ...data },
});

//GET User

export const getUserSuccess = (
  actionType: string,
  data: GetUser | {}
): UsersActionType => ({
  type: UsersActionTypes.GET_USER_SUCCESS,
  payload: { actionType, data },
});
export const getUserError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.GET_USER_ERROR,
  payload: { actionType, error },
});

export const getUser = (id: string): UsersActionType => ({
  type: UsersActionTypes.GET_USER,
  payload: { id },
});

//Update User Password
export const updateUserPasswordSuccess = (
  actionType: string,
  data: UserUpdatePassword | {}
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PASSWORD_SUCCESS,
  payload: { actionType, data },
});

export const updateUserPasswordError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PASSWORD_ERROR,
  payload: { actionType, error },
});

export const updateUserPassword = (
  id: string,
  data: UserUpdatePassword
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_PASSWORD,
  payload: { id, ...data },
});

//Update User Activation
export const updateUserActivationSuccess = (
  actionType: string,
  data: UserUpdateActivation | {}
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_ACTIVATION_SUCCESS,
  payload: { actionType, data },
});

export const updateUserActivationError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_ACTIVATION_ERROR,
  payload: { actionType, error },
});

export const updateUserActivation = (
  id: string,
  data: UserUpdateActivation
): UsersActionType => ({
  type: UsersActionTypes.UPDATE_USER_ACTIVATION,
  payload: { id, ...data },
});

//DELETE User

export const deleteUserSuccess = (
  actionType: string,
  data: DeleteUser | {}
): UsersActionType => ({
  type: UsersActionTypes.DELETE_USER_SUCCESS,
  payload: { actionType, data },
});
export const deleteUserError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.DELETE_USER_ERROR,
  payload: { actionType, error },
});

export const deleteUser = (ids: string[]): UsersActionType => ({
  type: UsersActionTypes.DELETE_USER,
  payload: { ids },
});

// Download Exel Users Sheet
//User_List
export const usersDownloadSuccess = (
  actionType: string,
  data: UsersData | {}
): UsersActionType => ({
  type: UsersActionTypes.DOWNLOAD_USERS_SUCCESS,
  payload: { actionType, data },
});
export const usersDownloadError = (
  actionType: string,
  error: string
): UsersActionType => ({
  type: UsersActionTypes.DOWNLOAD_USERS_ERROR,
  payload: { actionType, error },
});

export const DownloadUserList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  role: string = "",
  country: string = ""
): UsersActionType => ({
  type: UsersActionTypes.DOWNLOAD_USERS,
  payload: { keyword, limit, skip, role, country },
});
